import styled from "styled-components";

export const DashboardItems = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;  
  @media (max-width: 768px) { 
    width: 100%;
    padding: 10px;    
    box-sizing: border-box;
  }
`;

export const DashboardItem = styled.a<{ background: string }>`
  width: 335px;
  height: 150px;
  margin:10px;
  display: flex;
  border-radius: 10px;  
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: url(${({ background }) => background}) no-repeat center center;  
  background-size: cover;
  &:hover {    
    opacity: 0.8;
  }
  text-decoration: none;
  color: #fff;
`;

export const DrillQuotaLabel = styled.span`
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.7);
`;
